import { FC } from 'react';
import { Block } from '@ui-kit/Block';
import { BlockTypeProps } from './TypeProps';
import classNames from 'classnames';

import styles from './BlockBorderAnimation.module.scss';

export const BlockBorderAnimation: FC<BlockTypeProps> = ({ children, active, fullHeight, ...props }) => {
  return (
    <Block {...props} className={classNames(styles.Container, active && styles.Active, fullHeight && styles.FullHeight)}>
      {children}
    </Block>
  );
};
